module.exports = __webpack_public_path__ + "img/1.31c8177c.webp";